// import Reservation from './Reservation';

export default function (reservation, paymentId, creditCardUrl, pointsOnly) {
	this.reservation = reservation;
	this.id = paymentId;
	this.creditCardUrl = creditCardUrl;
	this.pointsOnly = pointsOnly;
}
